<template>
  <div>
    <b-row>
      <b-col md="12">
        <FormulateInput
          id="tax-configuration-group-tax-reform-enabled"
          v-model="taxReformEnabled"
          name="taxReformEnabled"
          type="switch"
          :label="$t('Configurar tributos da reforma nesta exceção')"
          :instruction="
            $t(
              'Desligado, o produto usa o parâmetro fiscal do NCM. Ao ligar, os campos vêm preenchidos com essa configuração para você ajustar.'
            )
          "
        />
      </b-col>
    </b-row>

    <div v-if="taxReformEnabled">
      <b-row>
        <b-col md="4">
          <FormulateInput
            id="tax-configuration-group-st-cbs-ibs"
            v-model="form.stCbsIbsCode"
            name="stCbsIbsCode"
            type="vue-select"
            :options="comboCst"
            :placeholder="$t('Mantém o do NCM')"
            :label="$t('Situação Trib. CBS/IBS')"
            :instruction="
              $t(
                'Quando informada, todo o bloco de CBS/IBS desta exceção substitui o do parâmetro fiscal do NCM'
              )
            "
          />
        </b-col>
        <b-col md="5">
          <FormulateInput
            id="tax-configuration-group-fiscal-classification-cbs-ibs"
            v-model="form.fiscalClassificationCbsIbsCode"
            name="fiscalClassificationCbsIbsCode"
            type="vue-select"
            :options="comboCbsIbsClassTribs"
            :placeholder="$t('Selecione')"
            :disabled="!hasCbsIbs"
            :class="hasCbsIbs ? 'required' : ''"
            :validation="hasCbsIbs ? 'required' : ''"
            :label="$t('Classificação CBS/IBS')"
          />
        </b-col>
      </b-row>

      <b-row v-if="cbsIbsRatesVisible">
        <b-col md="4">
          <FormulateInput
            id="tax-configuration-group-cbs-percent"
            v-model="form.cbsPercent"
            name="cbsPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            validation="required|number|min:0.0000|max:1"
            :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
            :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_PERCENT')"
            class="required"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="tax-configuration-group-cbs-reduction-percent"
            v-model="form.cbsReductionPercent"
            name="cbsReductionPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            validation="required|number|min:0.0000|max:1"
            :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
            :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_REDUCTION_PERCENT')"
            class="required"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="tax-configuration-group-cbs-deferral-percent"
            v-model="form.cbsDeferralPercent"
            name="cbsDeferralPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            validation="required|number|min:0.0000|max:1"
            :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
            :label="$t('FISCAL_TAX_PARAMETER.LABEL.CBS_DEFERRAL_PERCENT')"
            class="required"
          />
        </b-col>
      </b-row>

      <div v-if="cbsIbsRatesVisible">
        <h6 class="mb-1 mt-1">
          {{ $t('IBS Estadual') }}
        </h6>
        <b-row class="mb-2">
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-state-percent"
              v-model="form.ibsStatePercent"
              name="ibsStatePercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_PERCENT')"
              class="required"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-state-reduction-percent"
              v-model="form.ibsStateReductionPercent"
              name="ibsStateReductionPercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_REDUCTION_PERCENT')"
              class="required"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-state-deferral-percent"
              v-model="form.ibsStateDeferralPercent"
              name="ibsStateDeferralPercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_DEFERRAL_PERCENT')"
              class="required"
            />
          </b-col>
        </b-row>

        <h6 class="mb-1 mt-1">
          {{ $t('IBS Municipal') }}
        </h6>
        <b-row>
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-municipal-percent"
              v-model="form.ibsMunicipalPercent"
              name="ibsMunicipalPercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_PERCENT')"
              class="required"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-municipal-reduction-percent"
              v-model="form.ibsMunicipalReductionPercent"
              name="ibsMunicipalReductionPercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_REDUCTION_PERCENT')"
              class="required"
            />
          </b-col>
          <b-col md="4">
            <FormulateInput
              id="tax-configuration-group-ibs-municipal-deferral-percent"
              v-model="form.ibsMunicipalDeferralPercent"
              name="ibsMunicipalDeferralPercent"
              type="text-percetage"
              currency="%"
              :precision="5"
              validation="required|number|min:0.0000|max:1"
              :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
              :label="$t('FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_DEFERRAL_PERCENT')"
              class="required"
            />
          </b-col>
        </b-row>
      </div>

      <hr class="mt-2">

      <h6 class="mb-1">
        {{ $t('Imposto Seletivo') }}
      </h6>
      <b-row>
        <b-col md="3">
          <FormulateInput
            id="tax-configuration-group-st-selective-tax"
            v-model="form.stSelectiveTaxCode"
            name="stSelectiveTaxCode"
            type="vue-select"
            :options="comboCst"
            :placeholder="$t('Mantém o do NCM')"
            :label="$t('Situação Trib. Imposto Seletivo')"
            :instruction="
              $t(
                'Quando informada, todo o bloco do Imposto Seletivo desta exceção substitui o do parâmetro fiscal do NCM'
              )
            "
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="tax-configuration-group-fiscal-classification-selective-tax"
            v-model="form.fiscalClassificationSelectiveTaxCode"
            name="fiscalClassificationSelectiveTaxCode"
            type="vue-select"
            :options="comboSelectiveTaxClassTribs"
            :placeholder="$t('Selecione')"
            :disabled="!hasSelectiveTax"
            :class="hasSelectiveTax ? 'required' : ''"
            :validation="hasSelectiveTax ? 'required' : ''"
            :label="$t('Classificação Imposto Seletivo')"
          />
        </b-col>
        <b-col md="3">
          <FormulateInput
            id="tax-configuration-group-selective-tax-type"
            v-model="form.selectiveTaxType"
            name="selectiveTaxType"
            type="vue-select"
            :options="comboSelectiveTaxTypes"
            :placeholder="$t('Selecione')"
            :disabled="!hasSelectiveTax"
            :class="hasSelectiveTax ? 'required' : ''"
            :validation="hasSelectiveTax ? 'required' : ''"
            :label="$t('Tipo de Imposto Seletivo')"
          />
        </b-col>
        <b-col
          v-if="hasSelectiveTax && form.selectiveTaxType === 'PERCENTAGE_BY_BASE_VALUE'"
          md="2"
        >
          <FormulateInput
            id="tax-configuration-group-selective-tax-percent"
            v-model="form.selectiveTaxPercent"
            name="selectiveTaxPercent"
            type="text-percetage"
            currency="%"
            :precision="4"
            validation="required|number|min:0.00|max:1"
            :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
            :label="$t('% Imposto Seletivo')"
            class="required"
          />
        </b-col>
        <b-col
          v-if="hasSelectiveTax && form.selectiveTaxType === 'PERCENTAGE_BY_UNIT'"
          md="2"
        >
          <FormulateInput
            id="tax-configuration-group-selective-tax-value-per-unit"
            v-model="form.selectiveTaxValuePerUnit"
            name="selectiveTaxValuePerUnit"
            type="text-percetage"
            currency="R$"
            :precision="4"
            validation="required|number|min:0.00|max:1"
            :validation-messages="{ ...mxGetTextPercentageValidationMessages }"
            :label="$t('Valor por Unidade Imposto Seletivo')"
            class="required"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { alerts, formulateHelper } from '@/mixins'

/**
 * Tributos da reforma no cabeçalho da exceção fiscal, atrás de um switch: desligado, o bloco vai
 * nulo para a API e o produto continua usando o parâmetro fiscal do NCM.
 *
 * Ligado, cada bloco — CBS/IBS e Imposto Seletivo — é tudo ou nada: a situação tributária é o
 * gatilho, e os dois blocos são independentes entre si.
 *
 * Os combos vêm do módulo dos parâmetros fiscais: são cadastros globais (CST e classificação da
 * reforma), não estado da tela do NCM.
 */
export default {
  name: 'TaxConfigurationGroupTaxReformForm',
  components: { BRow, BCol },
  mixins: [alerts, formulateHelper],

  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      /**
       * Ligado enquanto o pré-preenchimento escreve o bloco. Sem ele os watchers de situação
       * tributária limpariam a classificação e as alíquotas recém-carregadas.
       */
      prefilling: false,
    }
  },

  computed: {
    ...mapState('pages/invoice/taxConfigurationGroups/taxConfigurationGroupMaintain', {
      taxConfigurationGroup: state => state.taxConfigurationGroup,
      storedTaxReformEnabled: state => state.taxReformEnabled,
    }),
    ...mapGetters('pages/invoice/fiscalTaxParameters', [
      'getCstCbsIbs',
      'getClassTribsByCst',
      'getSelectiveTaxTypes',
    ]),

    form() {
      return this.taxConfigurationGroup
    },

    /**
     * Preencher e limpar ficam no setter, não em um watcher: assim só a interação com o switch
     * dispara, e carregar um cadastro gravado — que também liga o switch — não sobrescreve o que
     * já está lá com o padrão do NCM.
     */
    taxReformEnabled: {
      get() {
        return this.storedTaxReformEnabled
      },
      set(enabled) {
        // O FormulateInput devolve por `input` toda mudança que vem do v-model. Ligar o switch
        // pela carga do cadastro gravado chega aqui como se fosse clique do usuário: sem esta
        // comparação, o pré-preenchimento apagaria os valores já gravados no registro.
        if (enabled === this.storedTaxReformEnabled) return

        this.setTaxReformEnabled(enabled)

        if (enabled) {
          this.prefillFromDefaultConfiguration()
          return
        }

        // Desligar devolve o produto ao parâmetro fiscal do NCM: nada do bloco pode sobrar.
        this.setTaxReform({})
      },
    },

    hasCbsIbs() {
      return !!this.form.stCbsIbsCode
    },

    hasSelectiveTax() {
      return !!this.form.stSelectiveTaxCode
    },

    /**
     * Situação tributária sem tributação não tem alíquota a informar: esconder evita que o
     * usuário preencha um bloco que o XML não usa.
     */
    cbsIbsRatesVisible() {
      if (!this.hasCbsIbs) return false

      const cst = this.getCstCbsIbs.find(item => item.code === this.form.stCbsIbsCode)
      return !cst || cst.requiresTaxation === true
    },

    comboCst() {
      return this.getCstCbsIbs.map(cst => ({
        value: cst.code,
        label: `${cst.code} - ${cst.description}`,
      }))
    },

    comboCbsIbsClassTribs() {
      return this.mapClassTribs(this.form.stCbsIbsCode)
    },

    comboSelectiveTaxClassTribs() {
      return this.mapClassTribs(this.form.stSelectiveTaxCode)
    },

    comboSelectiveTaxTypes() {
      return this.getSelectiveTaxTypes.map(type => ({ value: type.value, label: type.label }))
    },
  },

  watch: {
    'taxConfigurationGroup.stCbsIbsCode': function onStCbsIbsChange(value, oldValue) {
      this.onCstChange(value, oldValue, 'fiscalClassificationCbsIbsCode')

      if (!value) this.clearCbsIbsRates()
    },

    'taxConfigurationGroup.stSelectiveTaxCode': function onStSelectiveTaxChange(value, oldValue) {
      this.onCstChange(value, oldValue, 'fiscalClassificationSelectiveTaxCode')

      if (!value) this.clearSelectiveTax()
    },

    'taxConfigurationGroup.fiscalClassificationCbsIbsCode':
      async function onFiscalClassificationCbsIbsChange(value) {
        if (!value || this.busy || this.prefilling) return

        await this.fillCbsIbsRates(value)
      },
  },

  async mounted() {
    try {
      await this.fetchCombos()

      // Na edição os combos dependentes precisam da CST já gravada para abrir preenchidos.
      if (this.form.stCbsIbsCode) await this.fetchClassTribsByCst(this.form.stCbsIbsCode)
      if (this.form.stSelectiveTaxCode) await this.fetchClassTribsByCst(this.form.stSelectiveTaxCode)
    } catch (error) {
      this.showGenericError({ error })
    }
  },

  methods: {
    ...mapActions('pages/invoice/fiscalTaxParameters', ['fetchCombos', 'fetchClassTribsByCst']),
    ...mapActions('pages/invoice/taxConfigurationGroups/taxConfigurationGroupMaintain', [
      'setTaxReformEnabled',
      'setTaxReform',
    ]),

    mapClassTribs(cstCode) {
      return this.getClassTribsByCst(cstCode).map(classTrib => ({
        value: classTrib.code,
        label: `${classTrib.code} - ${classTrib.description}`,
      }))
    },

    /** A classificação pertence a uma CST: trocar a CST invalida a que estava escolhida. */
    onCstChange(value, oldValue, classificationField) {
      if (value) this.fetchClassTribsByCst(value)

      if (this.busy || this.prefilling || value === oldValue) return

      this.form[classificationField] = null
    },

    clearCbsIbsRates() {
      if (this.prefilling) return

      this.form.cbsPercent = null
      this.form.cbsReductionPercent = null
      this.form.cbsDeferralPercent = null
      this.form.ibsStatePercent = null
      this.form.ibsStateReductionPercent = null
      this.form.ibsStateDeferralPercent = null
      this.form.ibsMunicipalPercent = null
      this.form.ibsMunicipalReductionPercent = null
      this.form.ibsMunicipalDeferralPercent = null
    },

    clearSelectiveTax() {
      if (this.prefilling) return

      this.form.selectiveTaxType = null
      this.form.selectiveTaxPercent = null
      this.form.selectiveTaxValuePerUnit = null
    },

    /**
     * Ao ligar o switch, o bloco abre com a configuração que ele vai substituir, para o usuário
     * ajustar só o que muda. A exceção começa igual ao padrão, nunca vazia.
     *
     * A origem é o parâmetro fiscal do NCM ao qual o cadastro é restrito. Sem NCM — ou sem
     * parâmetro cadastrado para ele — não há padrão a copiar, e sobram as alíquotas vigentes.
     */
    async prefillFromDefaultConfiguration() {
      this.prefilling = true

      try {
        const taxReform = (await this.fetchNcmTaxReform()) ?? (await this.fetchCurrentRates())

        this.setTaxReform(taxReform)

        await Promise.all(
          [taxReform.stCbsIbsCode, taxReform.stSelectiveTaxCode]
            .filter(Boolean)
            .map(cst => this.fetchClassTribsByCst(cst))
        )
      } finally {
        // Depois do flush dos watchers disparados pelas atribuições acima.
        this.$nextTick(() => {
          this.prefilling = false
        })
      }
    },

    /** Null quando o cadastro não é restrito a um NCM ou o NCM não tem parâmetro fiscal. */
    async fetchNcmTaxReform() {
      if (!this.form.ncm) return null

      try {
        const { data } = await this.$http.get('/api/tax/fiscal-tax-parameter', {
          params: { ncm: this.form.ncm },
        })

        if (!data) return null

        return {
          stCbsIbsCode: data.stCbsIbsCode,
          fiscalClassificationCbsIbsCode: data.fiscalClassificationCbsIbsCode,
          cbsPercent: data.cbsPercent,
          cbsReductionPercent: data.cbsReductionPercent,
          cbsDeferralPercent: data.cbsDeferralPercent,
          ibsStatePercent: data.ibsStatePercent,
          ibsStateReductionPercent: data.ibsStateReductionPercent,
          ibsStateDeferralPercent: data.ibsStateDeferralPercent,
          ibsMunicipalPercent: data.ibsMunicipalPercent,
          ibsMunicipalReductionPercent: data.ibsMunicipalReductionPercent,
          ibsMunicipalDeferralPercent: data.ibsMunicipalDeferralPercent,
          stSelectiveTaxCode: data.stSelectiveTaxCode,
          fiscalClassificationSelectiveTaxCode: data.fiscalClassificationSelectiveTaxCode,
          selectiveTaxType: data.selectiveTaxType,
          selectiveTaxPercent: data.selectiveTaxPercent,
          selectiveTaxValuePerUnit: data.selectiveTaxValuePerUnit,
        }
      } catch (error) {
        // 404 é o caso normal de NCM sem parâmetro fiscal: o fallback resolve.
        return null
      }
    },

    async fetchCurrentRates() {
      try {
        const { data } = await this.$http.get('/api/tax/tax-reform/rates')

        if (!data) return {}

        return {
          cbsPercent: data.cbsRatePercent,
          ibsStatePercent: data.effectiveIbsStateRatePercent ?? data.ibsStateDefaultRatePercent,
          ibsMunicipalPercent:
            data.effectiveIbsMunicipalRatePercent ?? data.ibsMunicipalDefaultRatePercent,
        }
      } catch (error) {
        this.showError({ message: this.$t('Falha ao buscar alíquotas vigentes') })
        return {}
      }
    },

    /**
     * Trocar a classificação à mão repõe a redução dela e as alíquotas vigentes, como na tela do
     * parâmetro fiscal do NCM.
     */
    async fillCbsIbsRates(classTribCode) {
      if (!this.cbsIbsRatesVisible) {
        this.clearCbsIbsRates()
        return
      }

      try {
        const { data } = await this.$http.get(`/api/tax/tax-reform/class-trib/${classTribCode}`)

        if (data) {
          this.form.cbsReductionPercent = data.cbsReductionPercent ?? this.form.cbsReductionPercent

          if (data.ibsReductionPercent != null) {
            this.form.ibsStateReductionPercent = data.ibsReductionPercent
            this.form.ibsMunicipalReductionPercent = data.ibsReductionPercent
          }
        }
      } catch (error) {
        this.showError({ message: this.$t('Falha ao buscar classificação fiscal') })
      }

      const rates = await this.fetchCurrentRates()

      Object.assign(this.form, rates)
    },
  },
}
</script>
